import { ModalTiteledWindow } from "./modalWindow.js";
import {TimePicker} from "../timePicker.js";

//import "./extend/dom.js";
export class ModalSelectTime extends ModalTiteledWindow {
   constructor(options) {
      super();

      this.elMain = HTMLElement.createFromHTML(`
         <div class="modal-select-time">
            <div class="buttons bottom-bar">
               <i class="btn-delete icon-cross button-circle"></i>
               <i class="btn-save icon-check button-circle"></i>
            </div>
         </div>
      `);
      

      this.timePicker = new TimePicker(options);
      this.elMain.appendChild(this.timePicker.getElement());

      this.appendToBody(this.elMain);

      this.timePicker.draw();

      setTimeout(() => this.show(), 1);

      this.options = options;

      this.elMain.querySelector('.btn-delete').onclick = () => {
         this.close();
      }

      this.elMain.querySelector('.btn-save').onclick = () => {
         if (this.options.onSelect) this.options.onSelect(this.timePicker.hour, this.timePicker.minute);
         this.close();
      }



   }

   setTime(hour, minute) {
      this.timePicker.hour = hour;
      this.timePicker.minute = minute;
   }

}
